<template>
  <div class="g-images-slider" v-bind="$attrs" v-on="$listeners">
    <a-carousel v-if="urls && urls.length > 0" v-bind="$attrs" v-on="$listeners">
      <!-- <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow">
        <a-icon type="left-circle" />
      </div>
      <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow">
        <a-icon type="right-circle" />
      </div> -->

      <div v-for="(item, index) in urls" :key="index" class="images-slider-item">
        <img :src="`${item}`" :style="`border-radius:${borderRadius}px`" />
      </div>
    </a-carousel>
    <Space v-else />
  </div>
</template>
<script>
import { generateSignedUrl } from '@/config/oss';

export default {
  props: {
    listData: {
      type: [Array, null, undefined],
      default: () => [],
    },
    borderRadius: {
      type: Number,
      default: 5,
    },
  },
  watch: {
    listData: {
      async handler(val) {
        await this.getUrl(val);
      },
      immediate: true,
    },
  },
  async created() {
    await this.getUrl(this.listData);
  },
  data() {
    return {
      urls: null,
    };
  },
  methods: {
    async getUrl(val) {
      if (val && val.length > 0) {
        const _icons = [];
        await Promise.all(
          val.map(async file => {
            const fullUrl = await generateSignedUrl({ objectKey: file });
            _icons.push(fullUrl);
          })
        );
        this.urls = _icons;
      }
    },
  },
};
</script>
<style lang="less">
.g-images-slider {
  height: 100%;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;

  .ant-carousel {
    height: 100%;
    width: 100%;

    // .custom-slick-arrow {
    //   width: 25px;
    //   height: 25px;
    //   font-size: 25px;
    //   color: #fff;
    //   background-color: rgba(31, 45, 61, 0.11);
    //   opacity: 0.3;
    //   z-index: 10000;

    //   &:before {
    //     display: none;
    //   }

    //   &:hover {
    //     opacity: 0.5;
    //   }

    //   h3 {
    //     color: #fff;
    //   }
    // }

    .slick-slider {
      height: 100%;
      .slick-list {
        height: 100%;
        .slick-track {
          height: 100%;
          .slick-slide {
            height: 100%;
            > div {
              height: 100%;

              .images-slider-item {
                display: flex !important;
                text-align: center;
                height: 100%;
                align-items: center;
                justify-content: center;
                img {
                  width: 100%;
                  height: 100%;
                  max-height: 185px;
                }

                // 图片报错
                .g-img-error {
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
